import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import travel from '../assets/images/travel-api.jpg';

const step = [
	'No minimum wallet',
	'Same day delivery',
	'Pre Integrated GDS & APIs.',
	'Multiple Supplier Inventory',
	'Offline Flight Inventory Management',
	'Real time booking',
	'Real time cancellation',
	'Real time availability',
	'Live Fare rules',
	'Responsive design',
	'All device support',
	'Custom B2C Home Page',
	'Logo Design',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const Travel = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${travel})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Travel API'S
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Travel API'S
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					"A magical and revolutionary portal at an unbelievable price"
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								To run an Online Travel Portal Business, all you need is
								suppliers who can provide you the resources / utilities /
								inventories. Now to crack and get good deals and availability
								with multiple suppliers is a tedious task. So, here comes the
								role of APIs. API is stand for Application Programming
								Interface. In Travel Industry, Travel APIs have data/inventories
								from different suppliers integrated at the backend. Now to get
								real time and maximum of the inventories integrated in your
								travel portal all you need is just a good Travel API. It is easy
								to implement and integrate with existing systems, ensuring that
								you will always be at the top of the technology edge. A travel
								web portal is not complete unless it has the integrations of
								flight APIs, Hotel APIs, Bus APIs, Cruise APIs and Car APIs.
							</p>
							<br />
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>Hotel API</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								Like Flight API, by integrating Hotel API with the web Portal,
								you can browse live hotel availabilities from the suppliers.
								Hotel API provides hotels live data where you can directly book
								Room, cancel Room, generate reports for booking and
								cancellation, etc. very easily and efficiently by integrating
								API in your portal.
							</p>
							<br />
							<p>
								Previously, the bookings/reservations were made offline. Offline
								systems were not easy to track and now through API all the
								bookings are made online directly. In this you can directly
								trace the bookings and check the real time status of the
								bookings made. You can yourself check all the bookings made by
								you at a single portal without depending on others as Hotel API
								provides the booking list and the real time status of bookings
								and availabilities.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						The fastest way to grow your business with the leader in Travel
						Technology Check out our options and features included.
					</p>
				</Container>
			</div>
			<Container style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
				<p style={{ fontSize: 14, fontWeight: 'bold' }}>
					Features of B2C Travel Portal:-
				</p>
			</Container>
			<Container style={{ marginTop: 10 }}>
				<Grid container>
					<Grid item xs={4}>
						{step.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step2.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
					<Grid item xs={4}>
						{step3.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Footer />
		</div>
	);
};

export default Travel;
